import React, { useEffect } from "react";
import { usePaymentStore } from "../../stores/StoreContext";
import { useCourtBooking } from "../../context/courtBookingContext";
import { Colors } from "../../utils/colors";
import { PaymentExpandedHeaderOld } from "../paymentExpandedHeader/PaymentExpandedHeaderOld";
import { PaymentDetailsOld } from "../paymentDetails/PaymentDetailsOld";
import { PayForPlayersOld } from "../payForPlayers/PayForAllPlayersOld";
import { PaymentOptionsOld } from "../paymentOptions/PaymentOptionsOld";

// Section with add card and wallet options and with include players for payment option

type props = {};

export const PaymentExpandedOld: React.FC<props> = () => {
  const paymentStore = usePaymentStore();
  const { userModel } = useCourtBooking();
  useEffect(() => {
    if (
      paymentStore.selectedPlayersToPay.find(
        (p) => p.userId.toString() === userModel?.userId.toString()
      ) === undefined
    ) {
      paymentStore.togglePlayerToPay({
        userId: parseInt(userModel?.userId ?? "0", 10) ?? -1,
        name: userModel?.name ?? "",
        userImageUrl: userModel?.userImageUrl ?? "",
        email: userModel?.email ?? "",
        clubRank: 0,
        matchesWon: 0,
        userRating: 0,
        count: 0,
        lastMatchDate: "",
      });
    }
    if (!paymentStore.isPaymentSummaryReviewed) {
      paymentStore.isPaymentSummaryReviewed = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userModel]);

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 20,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 20,
        paddingTop: 20,
        marginTop: 20,
        display: "flex",
        flexDirection: "column",
      }}>
      <PaymentExpandedHeaderOld />
      <PaymentDetailsOld />
      <PaymentOptionsOld />
      <div
        style={{
          width: "100%",
          height: 2,
          backgroundColor: Colors.lightGreyBackground,
          marginBottom: 30,
          marginTop: 10,
        }}
      />
      <PayForPlayersOld />
    </div>
  );
};
